import * as React from 'react';
import { SVGProps } from 'react';

const SvgSignOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#signOut_svg__a)' fill='#000'>
      <path d='M6.143 20H13a1.144 1.144 0 0 0 1.143-1.143v-1.714H13v1.714H6.143V5.143H13v1.714h1.143V5.143A1.144 1.144 0 0 0 13 4H6.143A1.144 1.144 0 0 0 5 5.143v13.714A1.144 1.144 0 0 0 6.143 20Z' />
      <path d='m14.478 14.62 2.049-2.049H8.428V11.43h8.099l-2.05-2.05.809-.808L18.714 12l-3.428 3.429-.808-.808Z' />
    </g>
    <defs>
      <clipPath id='signOut_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgSignOut;
